export default {
  default: () => import("/build/layouts/default.vue").then(m => m.default || m),
  "header-footer-layout": () => import("/build/layouts/header-footer-layout.vue").then(m => m.default || m),
  "no-footer-layout": () => import("/build/layouts/no-footer-layout.vue").then(m => m.default || m)
}